module.exports = __webpack_public_path__ + "static/media/stream.365c4049.svg";